import React from 'react';
import { useIdQueryHandler } from '~/hooks/useIdQueryHandler';
import { useDeals } from '~/hooks/useDeals';
import { useDealEstimations } from '~/hooks/deals/useDealEstimations';
import { useDealEstimationHistories } from '~/hooks/deals/useDealEstimationHistories';
import { useDealEstimationHeaders } from '~/hooks/deals/useDealEstimationHeaders';
import { estimationRequestSide } from '~/models/DealEstimationHeader';
import { isOwnStatus } from '~/models/Status';
import { dealConstructionContext } from '~/models/DealConstruction';
import { PATH as ESTIMATIONS_PATH } from '~/pages/deals/[id]/estimations';
import { PATH as ESTIMATIONS_EDIT_PATH } from '~/pages/deals/[id]/estimations/edit';
import { ConstructionNavigation } from './ConstructionNavigation';

type Props = {
  title: string;
};

export const ConstructionClientNavigation: React.FC<Props> = ({ title }) => {
  const dealId = useIdQueryHandler();
  const { data: deal } = useDeals().show(dealId);
  const { data: dealEstimationContext } = useDealEstimations().index(dealId);
  const { data: dealEstimationHistoryContext } =
    useDealEstimationHistories().index(dealId);
  const { data: dealEstimationHeaders } =
    useDealEstimationHeaders().index(dealId);
  const requestHeader =
    dealEstimationHeaders?.find((header) => header.status === 'request') ??
    null;
  const { data: requestHistoryContext, isLoading } =
    useDealEstimationHeaders().show(dealId, requestHeader && requestHeader.id);
  if (
    dealId === null ||
    deal === null ||
    isLoading ||
    dealEstimationContext === null ||
    dealEstimationHistoryContext === null
  ) {
    return null;
  }
  const ownManagement = isOwnStatus(deal.status);
  const requestSide = estimationRequestSide(deal, 'client');
  return (
    <ConstructionNavigation
      dealConstructionContext={dealConstructionContext(
        ownManagement,
        requestSide,
        dealEstimationHistoryContext,
        requestHistoryContext,
        dealEstimationContext
      )}
      detailPagePath={
        requestSide || ownManagement
          ? ESTIMATIONS_EDIT_PATH(dealId)
          : ESTIMATIONS_PATH(dealId)
      }
      title={title}
    />
  );
};
